var endPS = `
	gl_FragColor.rgb = combineColor(litArgs_albedo, litArgs_sheen_specularity, litArgs_clearcoat_specularity);
	gl_FragColor.rgb += litArgs_emission;
	#ifdef FOG_GRAVITY
	gl_FragColor.rgb = addFogWithGravity(gl_FragColor.rgb, vPositionW.y);
	#else
	#ifdef FOG_DUAL_COLOR
	gl_FragColor.rgb = addFogDualColor(gl_FragColor.rgb, dViewDirW);
	#else
	gl_FragColor.rgb = addFog(gl_FragColor.rgb);
	#endif
	#endif
	#ifndef HDR
	gl_FragColor.rgb = toneMap(gl_FragColor.rgb);
	gl_FragColor.rgb = gammaCorrectOutput(gl_FragColor.rgb);
	#endif
`;

export { endPS as default };
